var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.25 12.75V12.7575M5.25 5.25V5.2575M12.75 5.25V5.2575M12.75 10.5H10.5V12.75M15 10.5V10.5075M10.5 15H12.75M12.75 12.75H15V15M3.75 3H6.75C7.16421 3 7.5 3.33579 7.5 3.75V6.75C7.5 7.16421 7.16421 7.5 6.75 7.5H3.75C3.33579 7.5 3 7.16421 3 6.75V3.75C3 3.33579 3.33579 3 3.75 3ZM11.25 3H14.25C14.6642 3 15 3.33579 15 3.75V6.75C15 7.16421 14.6642 7.5 14.25 7.5H11.25C10.8358 7.5 10.5 7.16421 10.5 6.75V3.75C10.5 3.33579 10.8358 3 11.25 3ZM3.75 10.5H6.75C7.16421 10.5 7.5 10.8358 7.5 11.25V14.25C7.5 14.6642 7.16421 15 6.75 15H3.75C3.33579 15 3 14.6642 3 14.25V11.25C3 10.8358 3.33579 10.5 3.75 10.5Z",
    stroke: "#222222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.c4959ced622ca6af89525ed5ff2ee3ae.svg";
export { ForwardRef as ReactComponent };